import {useTranslation} from "react-i18next";
import React, {useContext, useEffect} from "react";
import { GlobalContext} from "../../../util/state/GlobalContextProvider";
import {RecoilRoot, useRecoilState, useSetRecoilState} from "recoil";
import {checkOutInModeState, checkOutInStepState, raFetchedDataState} from "./state";
import VehicleStatus from "./vehicle-status/VehicleStatus";
import ContentBody from "../common/content-body/ContentBody";
import CheckDamage from "./check-damage/CheckDamage";
import CheckEquipment from "./check-equipment/CheckEquipment";
import Summary from "./summary/Summary";

const CheckInOutOpr = (props: any) => {
    const {t} = useTranslation(['network', 'translation']);
    const {dispatchGlobalData} = useContext(GlobalContext);

    const [checkStep, setCheckStep] = useRecoilState(checkOutInStepState);
    const setCheckOutInMode = useSetRecoilState(checkOutInModeState);
    const setRaFetchedData = useSetRecoilState(raFetchedDataState);

    useEffect(() => {
        const data = {
             oprData: {
                 oprCallback:            props.oprCallback,
                 callbackButtonLabel:    props.callbackButtonLabel,
                 enableCounterPart:      props.enableCounterPart,
             },
            vehicle: {
                plate: {
                    description:    props.plate,
                    code:           props.plate,
                },
                kilometersOnStart:              props.currentKms,
                currentTermicTankFilling:       props.currentFuelLevelEighths,
                currentElectricTankFilling:     props.currentBatteryPercentage,
                brandDescription :              props.brandDescription,
                modelDescription :              props.modelDescription,
                enginePowerGroupCode:           props.enginePowerGroupCode,
                carClassDescription:            props.carClass
            },
            bypassDamagesEquipments:            props.bypassDamagesEquipments,
            idTenant:                           props.tenant
        };

        setRaFetchedData(data);
        setCheckOutInMode(props.viewType);
        setCheckStep({
            active: 0,
            numSteps: 4
        });
    }, []);

    return (
        <>
            <ContentBody>
                {  checkStep.active === 0 && <VehicleStatus /> }
                {  checkStep.active === 1 && <CheckDamage /> }
                {  checkStep.active === 2 && <CheckEquipment /> }
                {  checkStep.active === 3 && <Summary /> }
            </ContentBody>
        </>
    )
}

const CheckInOutOprWr = (props: any) => {
    return (
        <RecoilRoot key={'opr-check-out-in'}>
            <CheckInOutOpr {...props} />
        </RecoilRoot>
    )
}

export {
    CheckInOutOpr,
    CheckInOutOprWr
};